<template>
    <v-expand-transition>
        <div @click="formBlockClicked" v-if="isVisible" :style="blockStyle(schema)" :title="schema.name">
            <component
                v-if="controlName"
                :is="controlName"
                :schema="mergedSchema"
                :value="value"
                :context="context"
                @change="change"
                @focus="focus"
            />
            <!-- @change="$emit('change', $event)" -->

            <div v-if="shouldRenderFields" class="control-group" :class="{horizontal}">
                <template v-for="(field, fieldIndex) in childFields" >
                    <FormBlock 
                        :schema="field" 
                        :value="value" 
                        :horizontal="schema.horizontal" 
                        :context="context"
                        :key="fieldIndex"
                        @change="change"
                        @focus="focus"
                    />
                </template>
            </div>
    
        </div>
    </v-expand-transition>

</template>

<script>
import GroupControl from './blocks/GroupControl'
import SectionControl from './blocks/SectionControl'
import SwitchHeadingControl from './blocks/SwitchHeadingControl'

import TextControl from './blocks/TextControl'
import CheckboxControl from './blocks/CheckboxControl'
import CurrencyControl from './blocks/CurrencyControl'
import FileControl from './blocks/FileControl'
import HtmlControl from './blocks/HtmlControl'
import LinkControl from './blocks/LinkControl'
import NumberControl from './blocks/NumberControl'
import PaymentControl from './blocks/PaymentControl'
import RadioControl from './blocks/RadioControl'
import SectionHeadingControl from './blocks/SectionHeadingControl'
import SwitchControl from './blocks/SwitchControl'
import YesNoControl from './blocks/YesNoControl'
import DropdownLabelControl from './blocks/DropdownLabelControl'

import Utilities from '@/helpers/Utilities'
import Merger from './Merger'


import FileView from './viewers/FileView'
import MergeHelpers from '../helpers/MergeHelpers'


export default {

    data() {
        return {
        
        }
    },

    components: {
        TextControl, NumberControl, GroupControl, SectionControl, SwitchHeadingControl, SwitchControl, CheckboxControl, 
        FileControl, LinkControl, RadioControl, PaymentControl,
        FileView, SectionHeadingControl, HtmlControl, CurrencyControl, YesNoControl, DropdownLabelControl
    },
    
    props: {
        schema: [Object],
        value: [Boolean, Array, String, Number, Object],
        context: Object,
        horizontal: Boolean,
    },

    computed: {

        shouldRenderFields() {
            const theType = this.schema.type
            const excludes = ['Group', 'Section', 'group', 'section']
            return (!excludes.includes(theType) || !theType)
        },

        childFields() {
            return this.schema.fields || []
        },

        controlName() {
            if(!this.schema.type)
                return ""

            return (this.schema.type|| '').replace(' ', '')  + 'Control'
        },
        viewerName() {
            return this.schema.type.replace(' ', '')  + 'View'
        },

        isVisible() {
    
            const visible = this.schema.visible

            if(typeof visible == 'undefined')
                return true
            if(typeof visible == 'boolean')
                return visible

            const result = Merger.processExpressions(visible, this.value)

            // console.log('checking vis for ', this.schema.label, 'returns....', result)

            return result

        },

        mergedSchema() {
            const newSchema = {...this.schema}
            newSchema.label = Merger.processExpressions(newSchema.label, this.value)
            return newSchema
        }
    },

    methods: {

        clearInvisibleField() {
            this.value[this.schema.name] = null
        },

        formBlockClicked(e) {
            //console.log('### formblock clicked', this.schema)
        },
        blockStyle(field) {
            const style = {}
            if(this.horizontal) {
                style.minWidth = '130px';
                if(field.width) {
                    style['flex-basis'] = field.width
                    style['flex-grow'] = 1
                } else {
                    style['flex-grow'] = 5
                    style['flex-shrink'] = 5
                }
            }
            return style
        },

        change(newVal) {
            
            if(newVal && newVal.changed) {
                //console.log('Changes already made', newVal)
                this.$emit('change', newVal)
                return
            }

            const oldVal = this.value[this.schema.name]
            // console.log('Changing ' + this.schema.name + ' from', oldVal, 'to' , newVal)
            this.$set(this.value, this.schema.name, newVal)
            const changes = {
                type: 'Field Changed',
                changed: true,
                field: this.schema.name,
                old: oldVal,
                value: newVal,
                row: this.value,
            }
            this.$emit('change', changes)
        },

        focusFirst() {
            setTimeout( () => {
                if(Utilities.isMobile())
                    return
                let el = this.$el.querySelector("input")
                if(el) {
                    el.focus()
                    el.select()
                }
            },200)
        },

        focus(e, eventContext) {
            //console.log('fblock got focus', e, eventContext)
            this.$set(this.context, 'focusedField', this.schema.name)
        }

        // findMergeFields(searchString) {

        //     //console.log('findMegeFields', searchString)
            
        //     let matches = []
        //     let match
            
        //     do {
        //         match = String(searchString).match(/\[(.*?)\]/i)
        //         if(!match) 
        //             break

        //         let innerMatch = match[1]
        //         let outerMatch = match[0]

        //         const innerArr = innerMatch.split('|')
        //         const matchObj = {
        //             name: innerArr[0].trim(),
        //             text: outerMatch, 
        //             operations: []
        //         }
        //         for(let n = 1; n < innerArr.length; n++) {
        //             const operationArr = innerArr[n].split(':')
        //             matchObj.operations.push({
        //                 operator: operationArr[0].trim(),
        //                 value: (operationArr.length > 1 ? operationArr[1] : '').trim()
        //             })
        //         }

        //         matches.push(matchObj)
        //         searchString = searchString.replace(outerMatch, '')

        //     } while(match)

        //     return (matches)
        // }
    },

    created() {
        //make sure property exists before passing it down so it will be reactive...
        if(!this.value.hasOwnProperty(this.schema.name))
            this.$set(this.value, this.schema.name, null)

    },

    watch: {
        'isVisible': {
            handler: function(newVal) {
                if(!newVal) {
                    this.clearInvisibleField()

                }
            }
        }
       
    }
}
</script>

<style scoped>
.control-group {
    display:flex;
    flex-direction: column;
    gap: 16px;
    justify-content: center;
    /* align-items: center; */
}
.control-group.horizontal {
    flex-direction: row;
    gap: 16px;
    flex-wrap: wrap;
}

@supports (-webkit-touch-callout: none) {
    .control-group {
        margin-right:10px;
        margin-bottom: 14px; 
    }

}

</style>




// WEBPACK FOOTER //
// FormBlock.vue?30a7760a